import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VNavigationDrawer,
    {
      staticClass: "d-print-none side-bar",
      attrs: { clipped: _vm.$vuetify.breakpoint.lgAndUp, app: "" },
      model: {
        value: _vm.navState.drawer,
        callback: function ($$v) {
          _vm.$set(_vm.navState, "drawer", $$v)
        },
        expression: "navState.drawer",
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex d-lg-none justify-end mx-2 mt-2" },
        [
          _c(
            VBtn,
            { attrs: { icon: "" }, on: { click: _vm.hideDrawer } },
            [_c(VIcon, [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c(
        VList,
        { attrs: { dense: "" } },
        [
          _vm._l(_vm.displayableItems, function (item) {
            return [
              item.heading
                ? _c(
                    VRow,
                    {
                      key: `heading-${item.heading}`,
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [_c(VSubheader, [_vm._v(_vm._s(item.heading))])],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "text-center", attrs: { cols: "6" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "body-2 black--text",
                              attrs: { href: "#!" },
                            },
                            [_vm._v("EDIT")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : item.children
                ? _c(
                    VListGroup,
                    {
                      key: `group-${item.text}`,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  VListItem,
                                  { attrs: { link: "" } },
                                  [
                                    item.icon
                                      ? _c(
                                          VListItemAction,
                                          [
                                            _c(VIcon, [
                                              _vm._v(_vm._s(item.icon)),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      VListItemContent,
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(_vm._s(item.text)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.active,
                        callback: function ($$v) {
                          _vm.$set(item, "active", $$v)
                        },
                        expression: "item.active",
                      },
                    },
                    _vm._l(item.children, function (child, index) {
                      return _c(
                        VListItem,
                        {
                          key: `child-${item.text}-${index}`,
                          attrs: { link: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clickLink(child)
                            },
                          },
                        },
                        [
                          child.icon
                            ? _c(
                                VListItemAction,
                                [_c(VIcon, [_vm._v(_vm._s(child.icon))])],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VListItemContent,
                            [
                              _c(VListItemTitle, [
                                _vm._v(_vm._s(child.text)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    VListItem,
                    {
                      key: `single-${item.text}`,
                      attrs: { link: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clickLink(item)
                        },
                      },
                    },
                    [
                      item.icon
                        ? _c(
                            VListItemAction,
                            [_c(VIcon, [_vm._v(_vm._s(item.icon))])],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VListItemContent,
                        [_c(VListItemTitle, [_vm._v(_vm._s(item.text))])],
                        1
                      ),
                    ],
                    1
                  ),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "text-caption grey--text text-center mt-4 mb-2",
          staticStyle: { "line-height": "1.4" },
        },
        [
          _c("div", [
            _vm._v(_vm._s(_vm.buildStage)),
            _vm.buildCommit
              ? _c("span", [_vm._v(" · " + _vm._s(_vm.buildCommit))])
              : _vm._e(),
          ]),
          _vm.buildTime ? _c("div", [_vm._v(_vm._s(_vm.buildTime))]) : _vm._e(),
        ]
      ),
      _c("div", { staticStyle: { height: "80px" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }